<template>
    <div>
        <div class="card-item">
            <div class="card-title">
                <span>主体证书/资质信息</span>
            </div>
            <div class="card-content">
                <div class="card-content-search">
                    <el-input size="small" class="card-content-search-input" v-model="inputValue"
                              clearable
                              placeholder="请输入"></el-input>
                    <button class="card-content-search-btn" @click="serachData()">搜索</button>
                    <button :class="this.status != -1 ? 'card-content-search-add-able' : 'card-content-search-add'"
                            v-debounce="[saveData,'click',500]"><i class="el-icon-plus" style="margin: 0 5px"></i>新增
                    </button>
                </div>
                <div class="card-content-table">
                    <el-table
                            border
                            :data="ruleForm.tableList"
                            align="center"
                            style="width: 100%"
                            ref="table"
                            :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',}"
                            :row-key="getRowKeys"
                            :expand-row-keys="expands">
                        <el-table-column
                                label="序号"
                                type="index"
                                align="center"
                                width="50">
                            <template scope="scope">
                                <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="证书类别"
                                align="center"
                                prop="qualificationTypeName">
                            <template scope="scope">
                                <p>{{scope.row.qualificationTypeName || "--"}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="证书编号"
                                align="center"
                                prop="certNo">
                            <template scope="scope">
                                <p>{{scope.row.certNo || "--"}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="证书名称"
                                align="center"
                                prop="certName">
                            <template scope="scope">
                                <p>{{scope.row.certName || "--"}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="证书有效期至"
                                align="center"
                                prop="qualificationValidityEnd">
                            <template scope="scope">
                                <p>{{scope.row.qualificationValidityEnd | dateStrIntercept}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="资质名称"
                                align="center"
                                prop="qualificationName"
                                width="272">
                            <template scope="scope">
                                <p>{{scope.row.qualificationName || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="数据来源"
                                align="center"
                                prop="comeFrom">
                        </el-table-column>
                        <el-table-column
                                label="数据状态"
                                align="center"
                                prop="state">
                            <template scope="scope">
                                <p type="text" v-if="scope.row.state == 1" class="change-examine"><i
                                        class="examine-effective"></i><span>有效</span></p>
                                <p type="text" v-else-if="scope.row.state == 2" class="change-examine"><i
                                        class="examine-waitSubmit"></i><span>待生效</span></p>
                                <p type="text" v-else-if="scope.row.state == 3" class="change-examine"><i
                                        class="examine-invalid"></i><span>已作废</span></p>
                                <p type="text" v-else-if="scope.row.state == 4" class="change-examine"><i
                                        class="examine-waitSubmit"></i><span>待提交</span></p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="登记日期"
                                align="center"
                                prop="createTime">
                            <template scope="scope">
                                <p>{{scope.row.createTime | dateStrIntercept}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="作废日期"
                                align="center"
                                prop="cancelTime">
                            <template scope="scope">
                                <p>{{scope.row.cancelTime && scope.row.cancelTime.substring(0,11)}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" @click="toogleExpandTrue(scope.row)">查看</el-button>
                                <el-button type="text" v-if="scope.row.state == 4"
                                           @click="deleteData(scope.row,'ruleForm')">删除
                                </el-button>
                                <el-button type="text" v-if="scope.row.state == 1 || scope.row.state == 2"
                                           @click="voidData(scope.row)">作废
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand" width="1">
                            <template slot-scope="props">
                                <el-form :model="ruleForm" :ref="'ruleForm'+props.$index" label-width="130px"
                                         style="position: relative" inline>
                                    <el-row>
                                        <el-col :span="8">
                                            <el-form-item label="资质证书上传 : "
                                                          :prop="'tableList.'+props.$index+'.certFilePath'"
                                                          :rules="{required: true, message: '请上传资质证书', trigger: 'change'}">
                                                <!--                                                <imgUpload v-if="props.row.state == 4" :ruleForm="ruleForm" :backgroundType="4" :bankPhotoAddr.sync="ruleForm.certFilePath"/>-->
                                                <imgUpload v-if="props.row.state == 4" :ruleForm="ruleForm" :backgroundType="5" :bankPhotoAddr.sync="props.row.certFilePath"/>
                                                <imgUploadView  v-if="props.row.state != 4" :ruleForm.sync="ruleForm" :backgroundType="5" :imgUrl.sync="props.row.certFilePath"/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="16">
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-form-item label="证书类别 : "
                                                                  :prop="'tableList.'+props.$index+'.qualificationType'"
                                                                  size="small"
                                                                  :rules="{required: true, message: '请选择证书类别', trigger: 'change'}">
                                                        <el-select v-if="props.row.state == 4"
                                                                   v-model="props.row.qualificationType"
                                                                   @change="qualificationTypeChange(props.row.qualificationType)"
                                                                   placeholder="请选择" clearable>
                                                            <el-option v-for="(item,index) in qualificationTypeList"
                                                                       :key="index"
                                                                       :label="item.text"
                                                                       :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                        <span v-if="props.row.state != 4">{{props.row.qualificationTypeName}}</span>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="证书编号 : "
                                                                  :prop="'tableList.'+props.$index+'.certNo'"
                                                                  size="small"
                                                                  :rules="{required: true, message: '请输入证书编号', trigger: 'blur'}">
                                                        <el-input v-if="props.row.state == 4" v-model="props.row.certNo"
                                                                  placeholder="请输入"
                                                                  clearable></el-input>
                                                        <span v-if="props.row.state != 4">{{props.row.certNo}}</span>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-form-item label="证书名称 : "
                                                                  :prop="'tableList.'+props.$index+'.certName'"
                                                                  size="small"
                                                                  :rules="{required: true, message: '请输入证书名称', trigger: 'blur'}">
                                                        <el-input v-if="props.row.state == 4"
                                                                  v-model="props.row.certName" placeholder="请输入"
                                                                  clearable></el-input>
                                                        <span v-if="props.row.state != 4">{{props.row.certName}}</span>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="发证机关 : "
                                                                  :prop="'tableList.'+props.$index+'.licenceOrg'"
                                                                  size="small"
                                                                  :rules="{required: true, message: '请输入发证机关', trigger: 'blur'}">
                                                        <el-input v-if="props.row.state == 4"
                                                                  v-model="props.row.licenceOrg" placeholder="请输入"
                                                                  clearable></el-input>
                                                        <span v-if="props.row.state != 4">{{props.row.licenceOrg}}</span>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-form-item label="发证日期 : "
                                                                  :prop="'tableList.'+props.$index+'.sendTime'"
                                                                  size="small"
                                                                  :rules="{required: true, message: '请输入发证日期', trigger: 'change'}">
                                                        <el-date-picker
                                                                v-if="props.row.state == 4"
                                                                v-model="props.row.sendTime"
                                                                :picker-options="pickerOptionsStart"
                                                                @change="changeEnd(props.row.sendTime)"
                                                                type="date"
                                                                placeholder="请选择日期时间">
                                                        </el-date-picker>
                                                        <span v-if="props.row.state != 4">{{props.row.sendTime | dateStrIntercept}}</span>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="证书有效期限至 : "
                                                                  :prop="'tableList.'+props.$index+'.qualificationValidityEnd'"
                                                                  size="small"
                                                                  :rules="{required: true, message: '请输入证书有效期限至', trigger: 'change'}">
                                                        <el-date-picker
                                                                :picker-options="pickerOptionsEnd"
                                                                v-if="props.row.state == 4"
                                                                v-model="props.row.qualificationValidityEnd"
                                                                @change="changeStart(props.row.qualificationValidityEnd)"
                                                                type="date"
                                                                placeholder="请选择日期时间">
                                                        </el-date-picker>
                                                        <span v-if="props.row.state != 4">{{props.row.qualificationValidityEnd | dateStrIntercept}}</span>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row v-if="ruleForm.qualificationType == 'A03' || props.row.qualificationType == 'A03'">
                                                <el-col>
                                                    <el-form-item ref="qualificationType" label="资质类别及等级 : "
                                                                  :prop="'tableList.'+props.$index+'.entQualificationCertLevels'"
                                                                  :rules="{required: true, message: '请选择资质等级', trigger: 'change'}">
                                                        <el-button v-if="props.row.state == 4" size="small"
                                                                   @click="addQualification(props.$index)"><i class="el-icon-plus" style="margin: 0 5px"></i>新增资质类别及等级
                                                        </el-button>
                                                        <qualificationAdd
                                                                :state="props.row.state"
                                                                :entQualificationCertLevels.sync="props.row.entQualificationCertLevels"
                                                                style="width: 814px;margin-top: 12px"
                                                        >
                                                        </qualificationAdd>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row v-if="ruleForm.qualificationType == 'A02' || props.row.qualificationType == 'A02'">
                                                <el-col>
                                                    <el-form-item ref="remark" label="许可范围 : "
                                                                  :prop="'tableList.'+props.$index+'.remark'"
                                                                  size="small"
                                                                  :rules="{required: true, message: '请输入许可范围', trigger: 'blur'}">
                                                        <el-input v-if="props.row.state == 4" type="textarea"
                                                                  v-model="props.row.remark" max="100" placeholder="请输入"
                                                                  clearable></el-input>
                                                        <span v-if="props.row.state != 4 && props.row.remark">{{props.row.remark}}</span>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </el-col>
                                    </el-row>
                                </el-form>
                                <div class="bottom-btn" v-if="props.row.state == 4">
                                    <el-button @click="deleteData(props.row,'ruleForm',props.$index)">取消</el-button>
                                    <el-button type="primary" @click="preservation(props.row,'ruleForm',props.$index)">
                                        保存
                                    </el-button>
                                </div>
                                <span @click="toogleExpandFalse(props.row)"
                                      style="position: absolute; bottom: 16px; right: 17px; font-weight: 400; color: #1890FF; font-size: 14px; cursor: pointer;">
                                    收起<i class="el-icon-arrow-up" style="color: #1890FF;margin-left: 4px;"></i>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="total, prev, pager, next"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog title="资质选择" width="95%" :before-close="handleDialogClose"
                   :visible.sync="dialogQualificationVisible">
            <div class="dialog-content">
                <aside>
                    <div class="aside-top-select">
                        <el-select v-model="asideTopSelect" @change="typeChange" :disabled="seleAble" placeholder="请选择"
                                   size="small" clearable>
                            <el-option label="旧资质" :value="1"></el-option>
                            <el-option label="新资质" :value="2"></el-option>
                        </el-select>
                        <!--                        <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">-->
                        <!--                            <i class="el-icon-question" style="font-size: 14px;margin: 0 0 0 9px"></i>-->
                        <!--                        </el-tooltip>-->
                        <i @click="goHelp" class="el-icon-question"
                           style="font-size: 14px;margin: 0 0 0 9px; cursor: pointer"></i>
                    </div>
                    <div class="aside-select-list">
                        <div v-for="(item,index) in sideList" :key="index" class="list-item">
                            <p @click="switchSide(item.id,index)" :class="actiove == index ?'active' : null">
                                <em>{{ item.code }}</em>
                                <span>{{ item.name }}</span>
                            </p>
                            <ul>
                                <li v-for="(i,x) in item.children" :key="x"
                                    @click="switchSideChild(item.id,x,index)"
                                    :class="childActiove == x && childActiveTemp == index ? 'childActive' : null">
                                    <em>{{ i.code }}</em><span>{{ i.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </aside>
                <div class="dialog-center-content">
                    <div class="dialog-center-content-top">
                        <input v-model="dialogCenterTopSearchKey" placeholder="请输入"/>
                        <button @click="serchdialogCenterData">搜 索</button>
                        <el-checkbox v-model='checkAll' :indeterminate="isIndeterminate" @change="checkedAll">全选</el-checkbox>
                    </div>
                    <div class="dialog-center-content-main">
                        <el-checkbox-group v-model="checkGroups" @change="handleCheckChange">
                            <el-collapse v-for="(item,index) in containerList" :key="index" v-model="activeNames">
                                <el-collapse-item :title="item.code + ' ' + item.name" :name="index">
                                    <div class="check-items">
                                        <el-checkbox v-for="(i,x) in item.children" :key="x"
                                                     @change="checkBoxItem(i)"
                                                     :label="i.code">
                                            {{ i.code + ' ' + i.name }}
                                        </el-checkbox>
                                    </div>

                                </el-collapse-item>
                            </el-collapse>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="dialog-right-content">
                    <div class="dialog-right-content-title">
                        <span>已选择分类</span>
                        <i class="el-icon-delete" style="font-size: 16px;color: #F23030;cursor:pointer;"
                           @click="deleteAllQualification">&nbsp;&nbsp;删除全部</i>
                    </div>
                    <ul v-for="(item,index) in deleteList">
                        <li>
                            <p>{{ index+1 + '、 ' + item.code + ' ' + item.name }}</p>
                            <i class="el-icon-delete" style="font-size: 16px;color: #F23030;cursor:pointer;"
                               @click="deleteQualification(index)"></i>
                        </li>
                    </ul>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogQualificationVisibleCancel" size="small">取 消
                </el-button>
                <el-button type="primary" @click="dialogQualificationVisibleEvent()" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import dataDictionary from "../../../store/modules/dataDictionary";

    export default {
        name: "main-qualifications-form",
        data() {
            return {
                seleAble: false,
                isIndeterminate: true,
                checkAll: false,// 是否全选
                serchId: '',
                actiove: 0,
                childActiove: null,
                childActiveTemp: null,
                addQualificationIndex: '',
                deleteList: [], // 选择的数据(可删除)
                deleteListTemp: [], // 选择的数据(可删除)
                containerList: [], // 中间区域的数据
                sideList: [], // 左侧数据
                dialogQualificationVisible: false,
                asideTopSelect: 1,
                dialogCenterTopSearchKey: '',
                activeNames: [],
                checkGroups: [],
                getRowKeys(row) {
                    return row.id
                },
                pickerOptionsStart: {},
                pickerOptionsEnd: {},
                devStartTime: '',
                // 要展开的行，数值的元素是row的key值
                expands: [],
                inputValue: '',
                ruleForm: {
                    tableList: [],
                },
                currentPage: 1,
                pageSize: 10,
                total: 0,
                queryParameter: {
                    attachmentParamList: [], // 附件列表
                    entQualificationCertLevels: [], // 类别等级列表
                    certType: null, // 新旧资质
                    id: '', // id
                    entId: '', // 企业ID
                    entRoleCode: '', // 企业用户角色Code
                    certNo: '', // 证书编号
                    licenceOrg: '', // 发证机关
                    qualificationType: '', // 证书类别code
                    qualificationIndustry: '', // 资质行业code
                    qualificationSerial: '', // 资质序列code
                    qualificationProfessional: '', // 资质专业code
                    qualificationLevel: '', // 资质等级code
                    qualificationState: '', // 证书状态
                    entPrincipal: '', // 企业负责人
                    technicalDirector: '', // 技术负责人
                    entPrincipalJob: '', // 企业负责人职务
                    technicalDirectorJob: '', // 技术负责人职务
                    entPrincipalTitle: '', // 企业负责人职称Code
                    technicalDirectorTitle: '', // 技术负责人职称Code
                    qualificationValidityStart: '', // 开始资质有效期
                    qualificationValidityEnd: '', // 结束资质有效期
                    businessScope: '', // 可承担业务
                    state: '', // 状态
                    sendTime: '', // 核发日期
                    sendOrg: '', // 核发机关
                    remark: '', // 备注
                    delFlag: '', // 是否删除
                    createUser: '', // 创建者
                    createTime: '', // 创建时间
                    updateUser: '', // 修改者
                    updateTime: '', // 修改时间
                    cancelFlag: '', // 是否作废
                    cancelTime: '', // 作废时间
                    qualificationName: '', // 资质名称
                    certName: '', // 证书名称
                    comeFrom: '', // 数据来源
                    certFilePath: ''
                }
            }
        },
        computed: {
            ...mapState({
                id: (state) => state.user.orgId,
                entId: (state) => state.user.userinfo.userId,
                qualificationTypeList: (state) => state.dataDictionary.qualificationTypeList,
                status: (state) => state.user.state,
            })
        },
        created() {
            this.querData()
            this.$store.dispatch('dataDictionary/getQualificationTypeList');//获取证书类别
        },
        methods: {
            goHelp() {
                window.open('http://www.mohurd.gov.cn/wjfb/202012/t20201202_248288.html')
            },
            // 资质类型（新旧）
            typeChange() {
                this.deleteList.splice(0)
                this.querySide();
            },
            //新增资质类别与等级
            addQualification(index) {
                this.dialogQualificationVisible = true;
                this.addQualificationIndex = index;
                this.deleteList = [];
                this.checkGroups = [];
                if (this.ruleForm.tableList[this.addQualificationIndex].entQualificationCertLevels.length > 0 && this.ruleForm.tableList[this.addQualificationIndex].entQualificationCertLevels[0].qualificationSerialName) {
                    this.ruleForm.tableList[this.addQualificationIndex].entQualificationCertLevels.map((item,index)=>{
                        this.deleteList.push(Object.assign({},item,{
                            firstName: item.qualificationSerialName, //资质大类
                            firstCode: item.qualificationSerial, //资质大类
                            name: item.qualificationProfessionalName, //资质类型
                            code: item.qualificationProfessional, //资质类型
                            // qualificationLevel: (!!item.qualificationLevel ? item.qualificationLevel.split(',')[0] : ''), //资质等级
                            qualificationLevel: item.qualificationLevel ? item.qualificationLevel : '', //资质等级
                            qualificationName: item.qualificationSerialName + '-' + item.qualificationProfessionalName + (!!item.qualificationLevel ? '-' + item.qualificationLevel.split(',')[1] : '')
                        }))
                        this.deleteList.forEach((item,index)=>{
                            this.checkGroups.push(item.code)
                        })
                    })
                }
                if (this.deleteList.length > 0) {
                    this.seleAble = true
                } else {
                    this.seleAble = false
                }
                this.querySide();
            },
            //dialog确定
            dialogQualificationVisibleEvent() {
                this.dialogQualificationVisible = false;
                this.ruleForm.tableList[this.addQualificationIndex].entQualificationCertLevels = this.deleteListTemp;
            },
            //dialog取消
            dialogQualificationVisibleCancel(){
                this.dialogQualificationVisible = false;
            },
            // 点击 X 关闭对话框的回调
            handleDialogClose() {
                this.dialogQualificationVisibleCancel();
            },
            //checkbox change 事件
            checkBoxItem(item){
                let index = this.deleteList.findIndex((val) => val.code == item.code);
                if(index == -1){
                    this.deleteList.push(item);
                }else{
                    this.deleteList.splice(index,1);
                }
            },
            // 获取checkbook选择值
            handleCheckChange(val) {
                if (this.deleteList.length > 0) {
                    this.seleAble = true
                } else {
                    this.seleAble = false
                }
                let allCheckItems = [];
                this.containerList.forEach((item,index)=>{
                    item.children.forEach((ite,ind)=>{
                        allCheckItems.push(ite.code);
                    })
                })
                let checkedCount = val.length;
                this.checkAll = checkedCount === allCheckItems.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < allCheckItems.length;

            },
            // 控制全选反选
            checkedAll(value) {
                this.checkGroups = [];
                this.deleteList = [];
                if(value){
                    this.containerList.forEach((item,index)=>{
                        item.children.forEach((ite,ind)=>{
                            this.checkGroups.push(ite.code);
                            this.deleteList.push(ite);
                        })
                    })
                    this.ruleForm.tableList[this.addQualificationIndex].entQualificationCertLevels = this.deleteList.map((item,index)=>{
                        item.qualificationSerialName = item.firstName;//资质大类
                        item.qualificationSerial = item.firstCode;//资质大类
                        item.qualificationProfessionalName = item.name;//资质类型
                        item.qualificationProfessional = item.code;//资质类型
                        // item.qualificationLevel = (!!item.qualificationLevel ? item.qualificationLevel.split(',')[0] : '');//资质等级
                        item.qualificationLevel = item.qualificationLevel ? item.qualificationLevel : '';//资质等级
                        item.qualificationName = item.firstName + '-' + item.name + (!!item.qualificationLevel ? '-' + item.qualificationLevel.split(',')[1] : '');
                        return item;
                    })
                }else{
                    this.checkGroups = [];
                    this.deleteList = [];
                    this.isIndeterminate = false;
                }
                // this.checkGroups = this.containerList;
            },
            querySide() {
                this.$http.get('/qualification-dict/side/' + this.asideTopSelect).then((res) => {
                    if (res && res.data.code == 1) {
                        this.sideList = res.data.data
                    }
                    this.$http.post('/qualification-dict/sub-tree/' + this.sideList[0].id).then((res) => {
                        if (res && res.data.code == 1) {
                            this.containerList = res.data.data
                        }
                        // 默认全部展开
                        for (var i = 0; i < this.containerList.length; i++) {
                            this.activeNames.push(i)
                        }
                    });
                    this.serchId = this.sideList[0].id
                });
            },
            // 根据侧边一级内容的选择请求中间区域的数据
            switchSide(id, index) {
                this.serchId = id;
                this.actiove = index;
                this.childActiove = null;
                this.$http.post('/qualification-dict/sub-tree/' + id).then((res) => {
                    if (res && res.data.code == 1) {
                        this.containerList = res.data.data
                    }
                    // 默认全部展开
                    for (var i = 0; i < this.containerList.length; i++) {
                        this.activeNames.push(i)
                    }
                });
            },
            // 二级
            switchSideChild(id, x, index) {
                this.childActiove = x;
                this.childActiveTemp = index;
                this.actiove = index;
                this.$http.post('/qualification-dict/sub-tree/' + id).then((res) => {
                    if (res && res.data.code == 1) {
                        this.containerList = res.data.data
                    }
                    // 当前展开
                    this.activeNames = [];
                    this.activeNames.push(x);
                });
            },
            // 搜索弹框内的企业资质
            serchdialogCenterData() {
                this.$http.post('/qualification-dict/sub-tree/' + this.serchId,{
                    keyword:this.dialogCenterTopSearchKey
                }).then((res) => {
                    if (res && res.data.code == 1) {
                        this.containerList = res.data.data
                    }
                    // 默认全部展开
                    for (var i = 0; i < this.containerList.length; i++) {
                        this.activeNames.push(i)
                    }
                });
            },
            // 删除当前已选择的所有资质
            deleteAllQualification() {
                this.deleteList.splice(0, this.deleteList.length);
                this.checkGroups = [];
                if (this.deleteList.length > 0) {
                    this.seleAble = true
                } else {
                    this.seleAble = false
                }
            },
            // 删除当前已选择的资质
            deleteQualification(index) {
                this.deleteList.splice(index, 1);
                this.checkGroups.splice(index, 1);
                if (this.deleteList.length > 0) {
                    this.seleAble = true
                } else {
                    this.seleAble = false
                }
            },
            // 结束时间限制开始时间
            changeStart(endTime) {
                if (!endTime) {
                    this.pickerOptionsStart = {
                        disabledDate: {}
                    }
                    return
                }
                this.pickerOptionsStart = Object.assign({}, this.pickerOptionsStart, {
                    // 可通过箭头函数的方式访问到this
                    disabledDate: (time) => {
                        var times = ''
                        times = time.getTime() > endTime
                        return times
                    }
                })
            },
            // 开始时间 控制结束时间
            changeEnd(startTime) {
                if (!startTime) {
                    this.pickerOptionsEnd = {
                        disabledDate: {}
                    }
                    return
                }
                this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
                    disabledDate: (time) => {
                        return time.getTime() < startTime
                    }
                })
            },
            // 获取数据
            querData() {
                this.$http.post('/agency/entqualificationcert/list', {
                    page: this.currentPage,
                    rows: this.pageSize,
                    filter: {
                        entId: this.id
                    },
                    searchKey: this.inputValue,
                    orderBy: 'create_time desc'
                }).then((res) => {
                    if (res.data) {
                        this.ruleForm.tableList = res.data.rows;
                        this.currentPage = res.data.pageIndex;
                        this.pageSize = res.data.pageSize;
                        this.total = res.data.total;
                        if (this.ruleForm.tableList.length > 0 && !this.ruleForm.tableList[0].certNo) {
                            this.expands.push(this.ruleForm.tableList[0].id)
                        } else {
                            this.expands = [];
                        }
                        this.ruleForm.tableList.forEach((item, index) => {
                            item.sendTime = item.sendTime ? item.sendTime.replace(/-/g, '/') : '';
                            item.qualificationValidityEnd = item.qualificationValidityEnd ? item.qualificationValidityEnd.replace(/-/g, '/') : '';
                            item.createTime = item.createTime ? item.createTime.replace(/-/g, '/') : '';
                            item.cancelTime = item.cancelTime ? item.cancelTime.replace(/-/g, '/') : '';
                            if(item.entQualificationCertLevels.length > 0){
                                item.entQualificationCertLevels[0].qualificationLevel = item.entQualificationCertLevels[0].qualificationLevel+','+item.entQualificationCertLevels[0].qualificationLevelName;
                            }
                        })
                    }
                })
            },
            // 搜索
            serachData() {
                this.currentPage = 1;
                this.querData();
            },
            // 新增
            saveData() {
                if(this.status != -1){
                    this.$message({
                        message: '请先点击【发起变更】按钮，或将上次变更的内容提交通过后再【新增】！',
                        type: 'warning'
                    });
                }else{
                    for(let key in this.queryParameter){
                        if(key == 'attachmentParamList'){
                            this.queryParameter[key] = []
                        }else if(key == 'entQualificationCertLevels'){
                            this.queryParameter[key] = []
                        }else{
                            this.queryParameter[key] = ''
                        }
                    }
                    this.queryParameter.entId=this.id;
                    this.queryParameter.state=4;
                    this.$http.post('/agency/entqualificationcert/save',this.queryParameter).then((res)=>{
                        if(res.data.code == 1){
                            this.querData();
                        }else{
                            this.$message({
                                message: res.data.msg,
                                type: 'warning'
                            });
                            this.querData();
                        }
                    });
                }
            },
            // 删除/取消
            deleteData(row) {
                this.$http.post('/agency/entqualificationcert/delbyid?id=' + row.id).then((res) => {
                    if (res.data.code == 1) {
                        this.querData();
                        this.$notify({
                            title: '删除',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'success'
                        })
                    }else{
                        this.$notify({
                            title: '删除',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'warning'
                        });
                    }
                });
            },
            // 查看
            toogleExpandTrue(row) {
                this.pickerOptionsStart = {};
                this.pickerOptionsEnd = {};
                this.$refs.table.toggleRowExpansion(row, true)
            },
            // 收起
            toogleExpandFalse(row) {
                this.$refs.table.toggleRowExpansion(row, false)
            },
            // 作废
            voidData(row) {
                this.$http.post('/agency/entqualificationcert/cancel?id=' + row.id).then((res) => {
                    if (res.data.code == 1) {
                        this.querData();
                        this.$notify({
                            title: '作废',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'success'
                        })
                    }else{
                        this.$notify({
                            title: '作废',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'warning'
                        });
                    }
                });
            },
            // 保存
            preservation(row, formName, index) {
                this.deleteListTemp = row.entQualificationCertLevels;
                row.entQualificationCertLevels.forEach((item,index)=>{
                    if(item.qualificationLevel.split(',')[0] == ''){
                        row.entQualificationCertLevels = [];
                    }
                })
                this.$refs['ruleForm' + index].validate((valid) => {
                    if (valid) {
                        this.queryParameter.entId = this.id;
                        this.queryParameter.state = row.state;
                        this.queryParameter.id = row.id;
                        this.queryParameter.qualificationType = row.qualificationType;
                        this.queryParameter.certNo = row.certNo;
                        this.queryParameter.certName = row.certName;
                        this.queryParameter.licenceOrg = row.licenceOrg;
                        this.queryParameter.sendTime = row.sendTime;
                        this.queryParameter.qualificationValidityEnd = row.qualificationValidityEnd;
                        this.queryParameter.remark = row.qualificationType && row.qualificationType === 'A02' ? row.remark : '';
                        if(row.qualificationType && row.qualificationType === 'A03'){
                            this.queryParameter.entQualificationCertLevels = row.entQualificationCertLevels.map((item,index)=>{
                                item.qualificationLevel = (!!item.qualificationLevel ? item.qualificationLevel.split(',')[0] : '');//资质等级
                                return item;
                            })
                        }else{
                            this.queryParameter.entQualificationCertLevels = [];
                        }
                        this.queryParameter.certFilePath = row.certFilePath;
                        this.queryParameter.certType = this.asideTopSelect;
                        this.$http.post('/agency/entqualificationcert/save', this.queryParameter).then((res) => {
                            if (res.data.code == 1) {
                                this.querData();
                                this.$refs.table.toggleRowExpansion(row, false);
                                this.$notify({
                                    title: '保存',
                                    message: res.data.msg,
                                    position: 'bottom-right',
                                    type: 'success'
                                })
                                this.pickerOptionsStart = {};
                                this.pickerOptionsEnd = {};
                            } else {
                                this.$notify({
                                    title: '保存',
                                    message: res.data.msg,
                                    position: 'bottom-right',
                                    type: 'warning'
                                });
                            }
                            this.deleteList.splice(0)
                        });
                    } else {
                        row.entQualificationCertLevels = this.deleteListTemp;
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.querData();
            },
            //证书类型切换事件
            qualificationTypeChange(val) {
                this.$nextTick(() => {
                    if (val == 'A02') {
                        this.$refs.remark.clearValidate();
                    } else if (val == 'A03') {
                        this.$refs.qualificationType.clearValidate();
                    }
                })

            }
        },
        filters: {
            dateStrIntercept(str) {
                if (str && str.length > 0) {
                    return str.substring(0, 11);
                } else {
                    return '--'
                }
            }
        },
        watch:{
            deleteList:{
                immediate: true,
                deep: true,//深度监听
                handler(val,newVal) {
                    if(newVal && val.length == newVal.length){
                        this.deleteListTemp = this.deleteList.map((item,index)=>{
                            item.qualificationSerialName = item.firstName;//资质大类
                            item.qualificationSerial = item.firstCode;//资质大类
                            item.qualificationProfessionalName = item.name;//资质类型
                            item.qualificationProfessional = item.code;//资质类型
                            // item.qualificationLevel = (!!item.qualificationLevel ? item.qualificationLevel.split(',')[0] : '');//资质等级
                            item.qualificationLevel = item.qualificationLevel ? item.qualificationLevel : '';//资质等级
                            item.qualificationName = item.firstName + ' (' + item.name + (!!item.qualificationLevel ?  item.qualificationLevel.split(',')[1] : '')+') ';
                            return item;
                        });
                    }
                },

            }
        }
    }
</script>

<style lang="scss" scoped>
    // 点击后方向
    /deep/ .el-collapse-item__arrow.is-active {
        transform: rotate(-90deg);;
    }

    //  默认方向
    /deep/ .el-collapse-item__arrow, .el-tabs__nav {
        transform: rotate(90deg);
    }

    /deep/ .el-textarea__inner {
        width: 814px;
        height: 80px;
    }

    .bottom-btn {
        display: flex;
        justify-content: center;

        .el-button {
            width: 96px;
            height: 40px;
            margin: 20px 24px 20px 0;
        }
    }

    .card-content {
        .card-content-search {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            padding-top: 4px;
            margin-right: 12px;

            .card-content-search-input {
                width: 250px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 2px;
                outline: none;
            }

            .card-content-search-btn {
                width: 70px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 32px;
                cursor: pointer;
            }

            .card-content-search-add {
                width: 82px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                cursor: pointer;
                line-height: 32px;
                margin-left: 12px;
            }

            .card-content-search-add-able {
                width: 82px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                cursor: pointer;
                line-height: 32px;
                margin-left: 12px;
                opacity: 0.25;
            }
        }

        .card-content-table {
            margin: 16px 12px 0 12px;

            /deep/ .el-input__inner {
                width: 324px;
            }
        }
    }

    /deep/ .el-dialog__header {
        padding: 16px 21px 16px 32px;

        .el-dialog__title {
            font-size: 16px;
        }
    }

    /deep/ .el-dialog__body {
        padding: 0;
    }

    /deep/ .el-dialog__footer {
        padding: 12px 24px;
    }

    .dialog-content {
        display: flex;
        border-top: 1px solid #D8D8D8;
        border-bottom: 1px solid #D8D8D8;

        aside {
            width: 224px;
            border-right: 1px solid #D8D8D8;

            .aside-top-select {
                width: 224px;
                padding: 0 0 0 20px;
                margin: 8px 0;

                .el-select {
                    width: 164px;
                }
            }

            .aside-select-list {
                .list-item {
                    width: 100%;
                    cursor: pointer;

                    p {
                        padding: 7px 0;
                        color: #000000;
                        font-size: 16px;
                        display: flex;

                        em {
                            width: 23px;
                            font-style: normal;
                            margin: 0 0 0 28px;
                        }
                    }

                    .active {
                        background: rgba(24, 144, 255, 0.1);
                        border-right: 4px solid #1890FF;
                    }

                    ul {
                        width: 100%;

                        li {
                            padding: 7px 0 7px 51px;
                            display: flex;
                            color: #000000;

                            em {
                                font-style: normal;
                                width: 30px;
                            }
                            span {
                                width: 120px;
                                margin: 0 0 0 10px;
                            }
                        }

                        .childActive {
                            background: #E7F3FF;
                        }
                    }
                }
            }
        }

        .dialog-center-content {
            flex: 1;
            padding: 0 48px;

            .dialog-center-content-top {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 11px 0 37px 0;

                input {
                    width: 480px;
                    height: 40px;
                    outline: 0;
                    border: 1px solid #D9D9D9;
                    border-right: 0;
                    border-top-left-radius: 2px;
                    border-bottom-left-radius: 2px;
                    padding-left: 16px;
                }

                button {
                    width: 70px;
                    height: 40px;
                    border-top-right-radius: 2px;
                    border-bottom-right-radius: 2px;
                    border: 0;
                    background: #1890FF;
                    color: #ffffff;
                    cursor: pointer;
                    margin: 0 10px 0 0;
                }
            }

            .dialog-center-content-main {
                .el-collapse {
                    border: 0;

                    .el-collapse-item {
                        margin: 0 0 10px 0;
                        border-top: 1px solid #ebeef5;
                    }

                    /deep/ .el-collapse-item__content {
                        padding-bottom: 0;
                    }

                    /deep/ .el-collapse-item__header {
                        border-left: 1px solid #ebeef5;
                        border-right: 1px solid #ebeef5;
                        padding: 0 12px;
                        font-size: 16px;
                        color: #000000;
                    }

                    /deep/ .el-collapse-item__header.is-active {
                        border-bottom: 1px solid #ebeef5;
                    }

                    /deep/ .el-collapse-item__wrap {
                        border: 0;
                        padding: 12px 24px;
                    }

                    .check-items {
                        .el-checkbox {
                            width: 50%;
                            margin: 0 0 12px 0;
                        }
                    }
                }
            }
        }

        .dialog-right-content {
            width: 367px;
            border-left: 1px solid #D8D8D8;

            .dialog-right-content-title {
                width: 100%;
                height: 47px;
                line-height: 47px;
                border-bottom: 1px solid #EEEEEE;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 11px;

                span {
                    color: #000000;
                    font-size: 16px;
                }
            }

            ul {
                width: 100%;
                padding: 0 10px;

                li {
                    width: 100%;
                    height: 43px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px dashed #EEEEEE;
                    color: rgba(0, 0, 0, .8);
                    font-size: 14px;

                    p {
                        span {
                            margin: 0 0 0 5px;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1600px) {
        .card-content {
            .card-content-table {
                margin: 16px 12px 0 12px;

                /deep/ .el-input__inner {
                    width: 200px;
                }
            }
        }
    }
</style>